module.exports = __webpack_public_path__ + "img/additional-savings-mazda-gif.6939e4ce.gif";